import React from 'react';
import CommentAdd from '../../assets/icons/commentAdd.svg';
import CommentAddContrast from '../../assets/icons/commentAddContrast.svg';
import TooltipOneComponent from '../TooltipOne/TooltipOne.component';
import { useLayoutContext } from '../../Context/Layout.context';

export const ADD_ICON_DRAG_TYPE = 'ADD_ICON_DRAG_TYPE';

export interface CommentDraggableIconProps {
  className: string;
  onCommentDragStateChange: (isDragging: boolean) => void;
}

const CommentDraggableIcon: React.FC<CommentDraggableIconProps> = ({ className, onCommentDragStateChange }) => {
  const { highContrastMode } = useLayoutContext();

  const handleDragStart = (event: React.DragEvent<HTMLElement>) => {
    // For safari only
    event.dataTransfer.setData('text/plain', '');
    const img = document.createElement('img');
    img.setAttribute('style', 'position: absolute; left: -100px; top: -100px; z-index: -1; width: 16px; height: 16px;');
    document.body.appendChild(img);
    img.src =
      'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAYAAACpF6WWAAAABmJLR0QA/wD/AP+gvaeTAAAB6klEQVQ4jaXU22oUQRAG4G8no8FDFhFJQDF4iAYSFUSIIERzIYKHC0VBwUvfwBfwYbyVgAdQUMELvRBFRNxgPIshYHQlMSJqkl0vuodM1p0h6A9N011V/0xV9V8VxViBPRjERnShgW/4iOcYi3dLUCkgHMIRVFHHe3yP/lVsi/sUbuBFGWmK09iHl7iFiTYfrWAHjsYs7uI2mtDR4ngWe3EHV2KqRajjEVZhJN69bSUdxiFcx70SsjyaGMdaHBSy+pJE42ocxjPcXyZhHlcxiRNIMtL96MTNksDzOF5ga8TYbgyk8XKX0OF6CWkPkhL7K6EHg0l03IQ3JQHLQRPv0JtiTSSebXFKcCp3rmKl8OTgh7/LNYP+1GJK8y0OFUFRGTrjyu6m25A2kaSCUprCC8hjAZdy54v4jMuK0YXZJAZPC537X2zBZJZ6DbuFmv0rNmM9anlFDeE1vhYEjcX1u8B+Tpgdo9mf9sS9TOszQv3bYQR9wgCay0j7hbpOlZAWYViYVo/jkgp13IonOcdu4V1O4GcB2QYcE9T4FKOZIcX2uCc4g51YF+0Lwjj7IKSfDek+9OIXruGBOEtFp5M4EM/zgtTG8Ukoy4DQ1QyNmEENDwVlLUEFF4RBMi50f65Nqh3CzGxYFEsh/gB0DWxACG7/OwAAAABJRU5ErkJggg==';
    event.dataTransfer.setDragImage(img, 10, 10);

    onCommentDragStateChange(true);
  };

  return (
    <TooltipOneComponent title="Dodaj komentarz" placement="right">
      <div draggable="true" style={{ cursor: 'pointer' }} onDragStart={handleDragStart}>
        <img
          style={{ pointerEvents: 'none' }}
          className={className}
          tabIndex={0}
          src={highContrastMode ? CommentAddContrast : CommentAdd}
          alt="ikona dodawania komentarza na obrazie rozwiązania"
          onDragEnd={() => onCommentDragStateChange(false)}
        />
      </div>
    </TooltipOneComponent>
  );
};

export default CommentDraggableIcon;
